import React from 'react';
import { useHistory } from 'react-router';

import CloseIcon from '../../../assets/icons/Close';
import MailImg from '../../../assets/mail.svg';
import ErrorImg from '../../../assets/error.svg';
import { RouterPaths } from '../../../constants/routes';
import Button from '../../Button/Button';
import './SupportEmailModal.scss';

type PropsType = {
  onClose: () => void;
  theme?: 'light' | 'dark';
};

export const ErrorModal: React.FC<PropsType> = ({ onClose, theme = 'dark' }) => (
  <div className="ds-support-modal">
    <div className="ds-modal-close" title="close" onClick={onClose}>
      <CloseIcon stroke={theme === 'light' ? '#15112d' : 'white'} />
    </div>
    <div className="text-title-bold">Oops! Looks like something went wrong.</div>
    <img src={ErrorImg} alt="Email Sent" />
    <Button text="Try again" className="ds-app-button" onClick={onClose} />
  </div>
);

export const SuccessModal: React.FC<PropsType> = ({ onClose, theme = 'dark' }) => {
  const history = useHistory();
  const onOverviewClick = () => {
    onClose();
    history.push(RouterPaths.dashboard);
  };

  return (
    <div className="ds-support-modal">
      <div className="ds-modal-close" title="close" onClick={onClose}>
        <CloseIcon stroke={theme === 'light' ? '#15112d' : 'white'} />
      </div>
      <div className="text-title-bold">Your request has been successfully sent!</div>
      <img src={MailImg} alt="Email Sent" />

      <div className="text-standard">Our team will be in touch as soon as they can.</div>

      <Button text="Overview" className="ds-app-button" onClick={onOverviewClick} />
    </div>
  );
};
